import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [remember, setRemember] = useState(false);

  const handleLogin = async () => {
    const user = await login(identifier, password);

    if (!user) {
      setError("Invalid username/email or password");
      return;
    }

    setError("");

    if (user.role === "admin") navigate("/admin");
    else if (user.role === "manager") navigate("/admin");
    else navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-100 via-white to-emerald-100">

      {/* NAVBAR */}
      <nav className="bg-gradient-to-r from-blue-600 to-emerald-500 text-white shadow-lg">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">

          <Link
            to="/"
            className="flex items-center gap-2 text-2l font-bold tracking-wide"
          >
            <img src="/logo.png" alt="logo" className="h-8 w-8 object-contain" />
            Synoweb Banquet Booking
          </Link>

          <span className="text-sm opacity-90">
            Banquet Management System
          </span>

        </div>
      </nav>

      {/* LOGIN CONTENT */}
      <main className="flex-1 flex items-center justify-center px-4">

        <div className="bg-white shadow-2xl rounded-xl p-8 w-full max-w-md border">

          <h2 className="text-2xl font-bold text-center text-gray-700 mb-2">
            Welcome Back
          </h2>

          <p className="text-center text-gray-400 text-sm mb-6">
            Login to continue
          </p>

          {/* Username */}
          <div className="relative mb-4">
            <FaUser className="absolute top-3 left-3 text-gray-400" />

            <input
              type="text"
              placeholder="User or Email"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              className="w-full border rounded-lg pl-10 pr-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
            />
          </div>

          {/* Password */}
          <div className="relative mb-3">
            <FaLock className="absolute top-3 left-3 text-gray-400" />

            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border rounded-lg pl-10 pr-10 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
            />

            <button
              type="button"
              className="absolute top-3 right-3 text-gray-500"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {error && (
            <p className="text-red-500 text-sm mb-3">{error}</p>
          )}

          {/* Remember */}
          <div className="flex items-center justify-between mb-5 text-sm">
            <label className="flex items-center gap-2 text-gray-600">
              <input
                type="checkbox"
                checked={remember}
                onChange={() => setRemember(!remember)}
              />
              Remember me
            </label>

            <span className="text-blue-500 cursor-pointer hover:underline">
              Forgot password?
            </span>
          </div>

          {/* Button */}
          <button
            onClick={handleLogin}
            className="w-full bg-gradient-to-r from-blue-600 to-emerald-500 text-white py-2 rounded-lg font-semibold hover:opacity-90 transition"
          >
            Login
          </button>

          {/* Demo */}
          {/* <div className="text-xs text-gray-400 text-center mt-5">
            Demo users:
            <div>admin / manager / user</div>
            <div>Password: 123456</div>
          </div> */}

        </div>

      </main>

      {/* FOOTER */}
      <footer className="w-full bg-white border-t border-gray-200 py-3 shadow-sm">
  <p className="text-center text-sm text-gray-600">
    © {new Date().getFullYear()} All rights reserved • Powered by{" "}
    
    <a
      href="https://synowebtech.com/" // 🔁 replace with your actual URL
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold bg-gradient-to-r from-blue-600 to-emerald-500 bg-clip-text text-transparent hover:opacity-80 transition"
    >
      Synoweb
    </a>
  </p>
</footer>

    </div>
  );
}